import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Kurs_eura, ApiClientService } from '../../../../services/api-client.service';

@Component({
  selector: 'app-create-kurs-eura',
  templateUrl: './create-kurs-eura.component.html',
  styleUrls: ['./create-kurs-eura.component.scss']
})
export class CreateKursEuraComponent {
  @Input() set visible(value: boolean) {
    this.isVisible = value;
    if (value) {
      this.initializeForm();
    }
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() kursEuraCreated = new EventEmitter<Kurs_eura>();

  isVisible = false;
  loading = false;
  kursEuraForm!: FormGroup;
  maxDate = new Date();

  datumEditorOptions: any = {
    placeholder: 'Odaberite datum...',
    type: 'date',
    max: this.maxDate,
    displayFormat: "dd.MM.yyyy"
  };

  tekstEditorOptions: any = {
    placeholder: 'Unesite tekst kursa eura...',
    autoResizeEnabled: true,
    height: 100
  };

  constructor(
    private fb: FormBuilder, 
    private apiClient: ApiClientService
  ) {}

  onPopupShown() {
    this.initializeForm();
  }

  initializeForm() {
    this.kursEuraForm = this.fb.group({
      datum: [new Date().toISOString().split('T')[0], Validators.required],
      tekst: ['', Validators.required]
    });
  }

  onFieldDataChanged(e: any) {
    if (e.dataField && e.value !== undefined) {
      this.kursEuraForm.patchValue({
        [e.dataField]: e.value
      });
    }
  }

  onPopupHiding() {
    this.isVisible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.isVisible = false;
    this.visibleChange.emit(false);
    this.kursEuraForm.reset();
  }

  async onSubmit() {
    if (this.kursEuraForm.valid) {
      this.loading = true;

      try {
        const createdKursEura = await this.apiClient.kursEuraPOST(this.kursEuraForm.value);

        this.kursEuraCreated.emit(createdKursEura);
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.kursEuraForm.reset();

      } catch (error) {
        console.error('Error creating kurs eura:', error);
      } finally {
        this.loading = false;
      }
    } else {
      this.markFormGroupTouched(this.kursEuraForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
}